module.exports = __webpack_public_path__ + "static/6-7bfce7b4e98b98cbd234ff84587af705.jpg";